module.exports = __webpack_public_path__ + "static/media/image-placeholder.288980e0.svg";